





















site = require '@/../config/site'
$ = require 'jquery'

export default {
  name: 'main-nav'

  data: ->
    socialLinks: site.social.links
    open: false
    darkLogo: require '@/assets/images/lucre-games-indie-game-sacramento-logo-black.png'

  methods:
    toggle: -> @open = !@open

    goto: (selector, e) ->
      e.preventDefault()
      offset = 0
      if selector == '#contact'
        offset = 2000
      $('html, body').animate({ scrollTop: $(selector).offset().top + offset, easing: 'swing' }, 1000);
      @toggle() if @open

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global/MainNav.vue